import React from 'react';
import { Box, Button } from '@material-ui/core';

import { useStyles } from './styles';

export interface InputAdornmentProps {
  isIncremntBtnDisabled: boolean;
  isDecremntBtnDisabled: boolean;
  onIncrementBtnClick: () => void;
  onDecrementBtnClick: () => void;
}

export const InputAdornment = ({
  isIncremntBtnDisabled,
  isDecremntBtnDisabled,
  onIncrementBtnClick,
  onDecrementBtnClick,
}: InputAdornmentProps) => {
  const classes = useStyles();

  return (
    <Box flex={1}>
      <Button disabled={isIncremntBtnDisabled} classes={{ root: classes.button }} onClick={onIncrementBtnClick}>
        +
      </Button>
      <Button disabled={isDecremntBtnDisabled} classes={{ root: classes.button }} onClick={onDecrementBtnClick}>
        -
      </Button>
    </Box>
  );
};
